import React, { useState, useRef, useEffect, useContext } from 'react';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { connect } from 'react-redux';
import { Button, Modal, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Select from "../../components/AppSelect";
import 'react-datepicker/dist/react-datepicker.css';
import { DateTime, IANAZone } from 'luxon';
import moment from "moment-timezone";

import Grid from '../../components/Grid';
import { Show } from '../../hooks/Show';
import { PermissionContext } from '../../hooks/PermissionContext';
import { formatDateWithoutTimeZone } from '../../utils/formatDate';
import { getStatusBadgeByCode } from '../../utils/StatusUtils';
import { getDaysDiff, isNullOrUndefined } from '../../utils/functionsUtils';
import TrafficLight from '../../components/TrafficLight';
import CustomTooltip from '../../components/CustomTooltip';
import { noveltyManagementList } from '../../utils/enumsUtil';
import ReschedulingSolutionModal from '../../components/Modal/ReschedulingSolutionModal';
import ReschedulingCoordinadoraSolutionModal from '../../components/Modal/ReschedulingCoordinadoraModal';
import { getMinDate } from '../../constants/rescheduling/reschedulingConst';

const Swal = require('sweetalert2');
const idCoordinadoraOperators = [76, 208];

const ReschedulingTableComponent = ({
  currentTab,
  reduxGetClients,
  clients,
  reduxGetLogisticsOperators,
  logisticsOperators,
  reduxGetAddresses,
  addresses,
  reduxResetAddressForm,
  reduxGetAddress,
  rowEdited,
  reduxPatchReschedule,
  reschedule,
  countries,
  reduxGetCountries,
  reduxResetDepartment,
  reduxResetCity,
  reduxResetNeighborhood,
  reduxResetAddressReschedulingForm,
  reduxUploadReschedulesToDrive,
  reduxGetNovelties,
  novelties,
  reschedulingsByNovelty,
}) => {
  const { hasPermission } = useContext(PermissionContext);
  const isClient = hasPermission('feature:isClient')

  const modalForm = useForm({
    defaultValues: {
      rescheduleResolution: { value: 1 },
      dateReschedule: null,
      manualAddress: null,
      phone: null,
      country: null,
      countryISO: null,
      department: null,
      city2: null,
      neighborhood: null,
      collection: null,
      observations: null,
    }
  });

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    setValue: setValueSearch,
    getValues: getValuesSearch,
  } = useForm({});

  const customStyles = {
    menu: (base) => ({ ...base, zIndex: 9999 }),
    valueContainer: (baseStyles) => ({ ...baseStyles, maxHeight: "3.5vw", overflowY: "auto" }),
    singleValue: (baseStyles) => ({ ...baseStyles, width: "100%" }),
    control: (baseStyles) => ({ ...baseStyles, flexWrap: "nowrap" }) // Ajusta el valor según tus necesidades
  };

  const rescheduleResolution = modalForm.watch('rescheduleResolution', { value: 1 });

  const rangeRef = useRef()

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [search, setSearch] = useState('');
  const [isDownloading, setIsDownloading] = useState(false)
  const [showModalReschedule, setShowModalReschedule] = useState(false);
  const [showCoordinadoraModal, setShowCoordinadoraModal] = useState(false);
  const [valueManualAddress, setValueManualAddress] = useState('');
  const [filters, setFilters] = useState({})

  const trafficLightColors = [
    { show: true, value: 'rojo', label: <div className='row align-items-center'><span className='ml-3 mr-2 btn-xsm btn-circle red-light'></span>Prioridad Alta (Queda 1 Día)</div> },
    { show: true, value: 'naranja', label: <div className='row align-items-center'><span className='ml-3 mr-2 btn-xsm btn-circle orange-light'></span>Prioridad Media (Quedan 2 Días)</div> },
    { show: true, value: 'amarillo', label: <div className='row align-items-center'><span className='ml-3 mr-2 btn-xsm btn-circle yellow-light'></span> Prioridad Baja (Quedan 3 Días)</div> },
  ]

  const showReschedulingModal = (idOperator, currentTab) => {
    if (idCoordinadoraOperators.includes(idOperator) && (currentTab === "managedByKiki" || currentTab === "managedByCustomer")) {
      setValueManualAddress('');
      setShowCoordinadoraModal(true);
      return;
    }

    setValueManualAddress('');
    setShowModalReschedule(true);
  }

  const handleCloseReschedule = () => {
    setShowModalReschedule(false);
    reduxResetDepartment();
    reduxResetCity();
    reduxResetNeighborhood();
    reduxResetAddressReschedulingForm();
    modalForm.reset();
  };

  const handleCloseCoordinadoraModal = () => {
    setShowCoordinadoraModal(false);
    reduxResetDepartment();
    reduxResetCity();
    reduxResetNeighborhood();
    reduxResetAddressReschedulingForm();
    modalForm.reset();
  };

  const openReschedule = (row) => {
    if (row.attempts === 2) {
      Swal.fire({
        title: 'Señor usuario',
        text: 'Tener presente que se realizará el último intento de reprogramar esta orden',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#21b5ea',
        cancelButtonColor: '#858796',
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cerrar',
      }).then((result) => {
        if (result.isConfirmed) {
          reduxGetAddress({
            id: row.idAddress,
          });
          showReschedulingModal(row.idOperator, currentTab);
        }
      });
    } else {
      reduxGetAddress({
        id: row.idAddress,
      });
      showReschedulingModal(row.idOperator, currentTab);
    }
  };

  const changeEndDate = (dates) => {
    const [start, end] = dates;
    setValueSearch("from", DateTime.fromJSDate(start).setZone(new IANAZone("America/Bogota")).toFormat("yyyy-LL-dd"))
    setValueSearch("to", DateTime.fromJSDate(end).setZone(new IANAZone("America/Bogota")).toFormat("yyyy-LL-dd"))

    setDateRange(dates)
    rangeRef.current.handleFocus()
  };

  const ListReschedulingsByTypeNovelty = () => {
    const noveltyList = novelties &&
      Array.isArray(novelties) &&
      novelties.length > 0 &&
      novelties
        .filter((f) =>
          f.isActive === true &&
          (currentTab === "single" ||
            (noveltyManagementList &&
              noveltyManagementList[currentTab] &&
              Array.isArray(noveltyManagementList[currentTab]) &&
              noveltyManagementList[currentTab].some(n => n.code === f.code))
          )
        )
        .map((ele, _key) => ({
          value: ele.code,
          label: ele.description,
          id: ele.idNovelty,
        }));

    const idNoveltyList = noveltyList ? noveltyList.map(n => n.id) : [];
    return idNoveltyList.join(",");
  }

  const onSubmitSearch = () => {
    if (endDate < startDate) {
      Swal.fire('Información', 'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo', 'info');
      return;
    }
    let filters = {
      page: 1,
      search: search ? search : '',
      offset: offset,
    };
    if (getValuesSearch('idClient')) {
      filters = {
        ...filters,
        idClient: getValuesSearch('idClient'),
      };
    }
    if (getValuesSearch('idOperator')) {
      filters = {
        ...filters,
        idOperator: getValuesSearch('idOperator'),
      };
    }
    if (getValuesSearch('from') && getValuesSearch('to')) {
      filters = {
        ...filters,
        from: formatDateWithoutTimeZone(startDate),
        to: formatDateWithoutTimeZone(endDate),
      };
    }
    if (getValuesSearch('trafficLight')) {
      filters = {
        ...filters,
        trafficLight: getValuesSearch('trafficLight').value,
      };
    }
    if (getValuesSearch('novelty')) {
      filters = {
        ...filters,
        novelty: getValuesSearch('novelty').value,
      };
    }

    const listNovelties = (currentTab === "single") ? "" : ListReschedulingsByTypeNovelty();
    filters = {
      ...filters,
      listNovelties,
      typeManagement: currentTab,
    };

    reduxGetAddresses(filters);
    setFilters(filters)
  };

  const handleChangeMultiSelect = (type, value) => {
    const multi = {
      ...getValuesSearch(type),
      value
    }

    setValueSearch(type, String(multi.value.map(item => item.value)));
  }

  const handleDownloadData = () => {
    setIsDownloading(true);
    if (endDate < startDate) {
      Swal.fire('Información', 'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo', 'info');
      setIsDownloading(false);
      return;
    }
    const fileName = moment(new Date()).tz("America/Bogota").format("YYYY-MM-DD_HHmmss") + "-reschedulings-report.csv";

    let _data = {
      search: search ? search : '',
      fileName,
    };
    if (getValuesSearch('idClient')) {
      _data = {
        ..._data,
        shippers: getValuesSearch('idClient'),
      };
    }
    if (getValuesSearch('idOperator')) {
      _data = {
        ..._data,
        operators: getValuesSearch('idOperator'),
      };
    }
    if (getValuesSearch('trafficLight')) {
      _data = {
        ..._data,
        trafficLight: getValuesSearch('trafficLight').value,
      };
    }
    if (getValuesSearch('novelty')) {
      _data = {
        ..._data,
        novelty: getValuesSearch('novelty').value,
      };
    }
    if (getValuesSearch('from') && getValuesSearch('to')) {
      _data = {
        ..._data,
        from: formatDateWithoutTimeZone(startDate),
        to: formatDateWithoutTimeZone(endDate),
      };
    }

    const listNovelties = (currentTab === "single") ? "" : ListReschedulingsByTypeNovelty();
    _data = {
      ..._data,
      listNovelties,
      typeManagement: currentTab,
    };

    const token = window.localStorage.getItem("token");

    fetch(`${process.env.REACT_APP_REPORT_URL}/api/v1/reports/reschedulings`, {
      method: "POST",
      body: JSON.stringify(_data),
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.blob())
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName
        document.body.appendChild(a);
        a.click();
        a.remove();
      }).finally(() => setIsDownloading(false));;
  }

  const renderDownloadButton = () => {
    if (
      !addresses?.items?.length ||
      !addresses ||
      Object.keys(addresses).length === 0
    )
      return;

    if (isDownloading) {
      return (
        <Spinner animation="border" variant="primary" />
      );
    }

    return (
      <Button
        className='mr-2'
        variant='primary'
        type='button'
        onClick={handleDownloadData}
        id='btnDownload'>
        Descargar
      </Button>
    );
  }

  const columns = [
    {
      title: '#',
      render: (rowData) => {
        return <span>{rowData.idAddress}</span>;
      },
      field: 'idAddress',
      searchable: true,
      visible: true,
    },
    {
      title: 'Guía',
      render: (rowData) => {
        return <span>{rowData.trackingId}</span>;
      },
      field: 'trackingId',
      searchable: true,
      visible: hasPermission('feature:rescheduling-show-column-trackingid'),
    },
    {
      title: 'IdExterno',
      render: (rowData) => {
        return <span>{rowData.externalId}</span>;
      },
      field: 'externalId',
      searchable: true,
      visible: hasPermission('feature:rescheduling-show-column-externalid')
    },
    {
      title: 'Nombre Destinatario',
      render: (rowData) => {
        return <span>{rowData.receiverName}</span>;
      },
      visible: hasPermission('feature:rescheduling-show-column-receivername')
    },
    {
      title: 'Dirección Destinatario',
      render: (rowData) => {
        return <span>{rowData.receiverAddress}</span>;
      },
      field: 'address',
      searchable: true,
      visible: hasPermission('feature:show-recipient-address')
    },
    {
      title: 'Teléfono Destinatario',
      render: (rowData) => {
        return (
          <span>{rowData.receiverPhone}</span>
        );
      },
      field: 'reference1',
      searchable: true,
      visible: hasPermission('feature:show-reference1-address')
    },
    {
      title: 'Estado',
      render: (rowData) => getStatusBadgeByCode(rowData.state),
      visible: hasPermission('feature:rescheduling-show-column-state')
    },
    {
      title: 'Ciudad',
      render: (rowData) => {
        return <span>{rowData.city}</span>;
      },
      field: 'city',
      searchable: true,
      visible: hasPermission('feature:rescheduling-show-column-city')
    },
    {
      title: 'Novedad',
      render: (rowData) => {
        return <span>{rowData.novelty}</span>;
      },
      field: 'novelty',
      searchable: true,
      visible: hasPermission('feature:rescheduling-show-column-novelty')
    },
    {
      title: 'Comentario Novedad/Nota',
      render: (rowData) => {
        return <span>{rowData.comment}</span>;
      },
      visible: hasPermission('feature:rescheduling-show-column-noveltynote')
    },
    {
      title: 'Valor de recaudo',
      render: (rowData) => {
        return <span>{rowData.collection}</span>;
      },
      field: 'collection',
      searchable: true,
      visible: hasPermission('feature:rescheduling-show-column-collection')
    },
    {
      title: 'Producto',
      render: (rowData) => {
        return rowData.product?.length > 30
          ? <CustomTooltip data={rowData.product.split(',')} />
          : <span>{rowData.product}</span>;
      },
      visible: hasPermission('feature:rescheduling-show-column-product')
    },
    {
      title: 'Intentos',
      render: (rowData) => (
        <span className='badge badge-pill badge-light d-flex justify-content-center align-items-center'>
          {rowData.attempts}
        </span>
      ),
      visible: hasPermission('feature:rescheduling-show-column-attempts')
    },
    {
      title: 'Fecha Estado',
      render: (rowData) => {
        return (
          <span>
            {rowData.lastUpdateDate && String(rowData.lastUpdateDate).includes('/')
              ? DateTime.fromFormat(String(rowData.lastUpdateDate), "YYYY/MM/dd").toFormat('dd-MM-YYYY')
              : rowData.lastUpdateDate
                ? String(rowData.lastUpdateDate)
                : ''}
          </span>
        );
      },
      visible: hasPermission('feature:rescheduling-show-column-lastupdatedate')
    },
    {
      title: 'Fecha Creado',
      render: (rowData) => {
        return (
          <span>
            {rowData.createdDate && String(rowData.createdDate).includes('/')
              ? DateTime.fromFormat(String(rowData.createdDate), "YYYY/MM/dd").toFormat('dd-MM-YYYY')
              : rowData.createdDate
                ? String(rowData.createdDate)
                : ''}
          </span>
        );
      },
      visible: hasPermission('feature:rescheduling-show-column-createddate')
    },
    {
      title: 'Fecha Tentativa de Entrega',
      render: (rowData) => {
        return (
          <span>
            {rowData.deliveryDate && String(rowData.deliveryDate).includes('/')
              ? DateTime.fromFormat(String(rowData.deliveryDate), "YYYY/MM/dd").toFormat('dd-MM-YYYY')
              : rowData.deliveryDate
                ? String(rowData.deliveryDate)
                : ''}
          </span>
        );
      },
      visible: hasPermission('feature:rescheduling-show-column-rescheduleddate')
    },
    {
      title: 'Remitente',
      render: (rowData) => {
        return <span>{rowData.shipper}</span>;
      },
      visible: hasPermission('feature:show-client-address'),
    },
    {
      title: 'Operador',
      render: (rowData) => {
        return <span>{rowData.operator}</span>;
      },
      visible: hasPermission('feature:show-operator-address')
    },
    {
      title: 'Acciones',
      render: (rowData) => {
        return (
          <>
            {(currentTab !== 'automaticManagement') && (
              <Show when='feature:rescheduling'>
                <button
                  title='Reprogramar'
                  className='btn btn-warning btn-sm btn-circle mr-2'
                  type='button'
                  onClick={(e) => openReschedule(rowData)}>
                  <i className='fas fa-calendar fa-xs'></i>
                </button>
              </Show>
            )}
            <TrafficLight days={getDaysDiff(new Date(), rowData.lastUpdateDate)} />
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setDateRange([null, null]);
    resetSearch();
    setFilters(prevFilters => ({
      ...prevFilters,
      from: undefined,
      to: undefined
    }));
  }, [currentTab]);

  useEffect(() => {
    reduxGetNovelties({
      page: 1,
      search: "",
      offset: 1000,
      status: 11,
    });
    reduxGetClients();
    reduxGetLogisticsOperators();
    reduxGetCountries({
      page: 1,
      offset: 1000,
      search: '',
      isActive: true,
    });
    reduxResetAddressForm();
    reduxResetDepartment();
    reduxResetCity();
    reduxResetNeighborhood();

    setDateRange([null, null]);
    resetSearch();
    modalForm.reset();
    setShowModalReschedule(false);
    setShowCoordinadoraModal(false);
    reschedule = null;
  }, []);

  useEffect(() => {
    if (
      currentPage &&
      addresses &&
      Object.keys(addresses).length > 0 &&
      getValuesSearch('from') &&
      getValuesSearch('to')
    ) {
      let filters = {
        page: currentPage,
        offset: offset,
        search: search,
      };
      if (getValuesSearch('idClient')) {
        filters = {
          ...filters,
          idClient: getValuesSearch('idClient'),
        };
      }
      if (getValuesSearch('idOperator')) {
        filters = {
          ...filters,
          idOperator: getValuesSearch('idOperator'),
        };
      }
      if (getValuesSearch('trafficLight')) {
        filters = {
          ...filters,
          trafficLight: getValuesSearch('trafficLight').value,
        };
      }
      if (getValuesSearch('novelty')) {
        filters = {
          ...filters,
          novelty: getValuesSearch('novelty').value,
        };
      }
      const listNovelties = (currentTab === "single") ? "" : ListReschedulingsByTypeNovelty();
      filters = {
        ...filters,
        listNovelties,
        typeManagement: currentTab,
      };
      if (getValuesSearch('from') && getValuesSearch('to')) {
        filters = {
          ...filters,
          from: formatDateWithoutTimeZone(startDate),
          to: formatDateWithoutTimeZone(endDate),
        };
      }
      reduxGetAddresses(filters);
    }
  }, [currentPage]);

  useEffect(() => {
    if (reschedule) {
      Swal.fire('Proceso exitoso!', `Registro guardado`, 'success');
      setShowModalReschedule(false);
      let filters = {
        page: currentPage,
        offset: offset,
        search: search,
      };
      if (getValuesSearch('idClient')) {
        filters = {
          ...filters,
          idClient: getValuesSearch('idClient'),
        };
      }
      if (getValuesSearch('idOperator')) {
        filters = {
          ...filters,
          idOperator: getValuesSearch('idOperator'),
        };
      }
      if (getValuesSearch('trafficLight')) {
        filters = {
          ...filters,
          trafficLight: getValuesSearch('trafficLight').value,
        };
      }
      if (getValuesSearch('novelty')) {
        filters = {
          ...filters,
          novelty: getValuesSearch('novelty').value,
        };
      }
      const listNovelties = (currentTab === "single") ? "" : ListReschedulingsByTypeNovelty();
      filters = {
        ...filters,
        listNovelties,
        typeManagement: currentTab,
      };
      if (getValuesSearch('from') && getValuesSearch('to')) {
        filters = {
          ...filters,
          from: formatDateWithoutTimeZone(startDate),
          to: formatDateWithoutTimeZone(endDate),
        };
      }

      if (!isNullOrUndefined(startDate) && !isNullOrUndefined(endDate)) {
        reduxGetAddresses(filters);
      }
    }
  }, [reschedule]);

  useEffect(() => {
    if (!rescheduleResolution)
      return;

    if (rescheduleResolution.value !== 2) {
      modalForm.setValue('dateReschedule', null);
      modalForm.setValue('manualAddress', '');
      modalForm.setValue('phone', '');
      modalForm.setValue('observations', '');
    }
  }, [rescheduleResolution])

  return (
    <div>
      <div className='card shadow mb-4'>
        <div className='card-header py-3 d-flex justify-content-between'>
          <h6 className='m-0 font-weight-bold text-primary'>Listado de Reprogramaciones</h6>
          {/* <h6 className='m-0 text-primary'>Total de Reprogramaciones: {reschedulingsByNovelty.total}</h6> */}
        </div>
        <div className='card-body'>
          <form onSubmit={handleSubmitSearch(onSubmitSearch)}>
            <div className='row mb-1'>
              <div className='form-group col-md-3'>
                <label
                  className='form-label'>
                  Desde - Hasta
                </label>
                <DatePicker
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  ref={rangeRef}
                  selectsDisabledDaysInRange
                  onChange={changeEndDate}
                  dateFormat="yyyy-MM-dd"
                  className={'form-control'}
                  minDate={getMinDate(currentTab, isClient)}
                  maxDate={new Date()}
                  shouldCloseOnSelect={false}
                  required
                  isClearable
                />
              </div>
              <Show when='feature:show-client-address'>
                <div className='form-group col-md-3'>
                  <label
                    htmlFor='idClient'
                    className='form-label'>
                    Remitente
                  </label>
                  <Select
                    styles={customStyles}
                    isMulti
                    isClearable={true}
                    isDisabled={!startDate || !endDate}
                    {...registerSearch('idClient')}
                    id='idClient'
                    onChange={(value) => handleChangeMultiSelect('idClient', value)}
                    options={
                      clients && Object.keys(clients).length > 0
                        ? clients.items
                          .filter((f) => f.isActive)
                          .map((ele, key) => ({
                            value: ele.idCompany,
                            label: ele.description,
                          }))
                        : []
                    }
                  />
                </div>
              </Show>
              <Show when='feature:show-operator-address' whenNot={["feature:isClient"]}>
                <div className='form-group col-md-3'>
                  <label
                    htmlFor='idOperator'
                    className='form-label'>
                    Operador
                  </label>
                  <Select
                    styles={customStyles}
                    isClearable={true}
                    isDisabled={!startDate || !endDate}
                    {...registerSearch('idOperator')}
                    isMulti
                    id='idOperator'
                    onChange={(value) => handleChangeMultiSelect('idOperator', value)}
                    options={
                      logisticsOperators &&
                      Object.keys(logisticsOperators).length > 0 &&
                      logisticsOperators.items
                        .filter((f) => f.isActive === true)
                        .map((ele, key) => ({
                          value: ele.idCompany,
                          label: ele.description,
                        }))
                    }
                  />
                </div>
              </Show>
              <div className='form-group col-md-3'>
                <label
                  htmlFor='trafficLight'
                  className='form-label'>
                  Semáforo
                </label>
                <Select
                  id='trafficLight'
                  styles={customStyles}
                  isClearable={true}
                  isDisabled={!startDate || !endDate}
                  {...registerSearch('trafficLight')}
                  onChange={value => setValueSearch('trafficLight', value)}
                  options={trafficLightColors.filter(e => e.show)}
                />
              </div>
              <div className='form-group col-md-3'>
                <label
                  htmlFor='novelty'
                  className='form-label'>
                  Novedad
                </label>
                <Select
                  styles={customStyles}
                  isClearable={true}
                  isDisabled={!startDate || !endDate}
                  {...registerSearch('novelty')}
                  id='novelty'
                  onChange={(value) => setValueSearch('novelty', value)}
                  options={
                    novelties &&
                      Array.isArray(novelties) &&
                      novelties.length > 0
                      ? novelties
                        .filter(
                          (f) =>
                            f.isActive === true &&
                            (currentTab === "single" ||
                              (noveltyManagementList[currentTab] &&
                                Array.isArray(noveltyManagementList[currentTab]) &&
                                noveltyManagementList[currentTab].some((n) => n.code === f.code)))
                        )
                        .map((ele) => ({
                          value: ele.code,
                          label: ele.description,
                        }))
                      : []
                  }
                />
              </div>
              <div className='form-group d-flex flex-row align-items-end ml-3'>
                <Button
                  className='mr-2'
                  variant='primary'
                  type='submit'
                  id='btnSearch'>
                  Buscar
                </Button>
                {
                  renderDownloadButton()
                }
              </div>
            </div>
          </form>
          <Grid
            className='stickyAddress'
            cols={columns}
            data={addresses && Object.keys(addresses).length > 0 ? addresses.items : []}
            total={addresses && addresses.hasOwnProperty('total') ? addresses.total : 0}
            page={addresses && Object.keys(addresses).length > 0 ? Number(addresses.page) : currentPage}
            pages={addresses && Object.keys(addresses).length > 0 ? Number(addresses.totalPages) : 0}
            offset={offset}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRange={(value) => {
              setOffset(value);
              let filters = {
                page: 1,
                offset: value,
                search: search,
              };
              if (getValuesSearch('trafficLight')) {
                filters = {
                  ...filters,
                  trafficLight: getValuesSearch('trafficLight').value,
                };
              }
              if (getValuesSearch('idClient')) {
                filters = {
                  ...filters,
                  idClient: getValuesSearch('idClient'),
                };
              }
              if (getValuesSearch('idOperator')) {
                filters = {
                  ...filters,
                  idOperator: getValuesSearch('idOperator'),
                };
              }
              if (getValuesSearch('novelty')) {
                filters = {
                  ...filters,
                  novelty: getValuesSearch('novelty').value,
                };
              }

              const listNovelties = (currentTab === "single") ? "" : ListReschedulingsByTypeNovelty();
              filters = {
                ...filters,
                listNovelties,
                typeManagement: currentTab,
              };

              if (getValuesSearch('from') && getValuesSearch('to')) {
                if (endDate < startDate) {
                  Swal.fire(
                    'Información',
                    'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo',
                    'info'
                  );
                  return;
                }
                filters = {
                  ...filters,
                  from: formatDateWithoutTimeZone(startDate),
                  to: formatDateWithoutTimeZone(endDate),
                };
              } else {
                return;
              }
              reduxGetAddresses(filters);
            }}
            defaultValue={search}
            onChangeSearch={(value) => {
              setSearch(value);
              let filters = {
                page: 1,
                offset: offset,
                search: value,
              };
              if (getValuesSearch('trafficLight')) {
                filters = {
                  ...filters,
                  trafficLight: getValuesSearch('trafficLight').value,
                };
              }
              if (getValuesSearch('novelty')) {
                filters = {
                  ...filters,
                  novelty: getValuesSearch('novelty').value,
                };
              }
              if (getValuesSearch('idClient')) {
                filters = {
                  ...filters,
                  idClient: getValuesSearch('idClient'),
                };
              }
              if (getValuesSearch('idOperator')) {
                filters = {
                  ...filters,
                  idOperator: getValuesSearch('idOperator'),
                };
              }

              const listNovelties = (currentTab === "single") ? "" : ListReschedulingsByTypeNovelty();
              filters = {
                ...filters,
                listNovelties,
                typeManagement: currentTab,
              };

              if (getValuesSearch('from') && getValuesSearch('to')) {
                if (endDate < startDate) {
                  Swal.fire(
                    'Información',
                    'La fecha inicial debe ser  menor a la fecha final , intenta de nuevo',
                    'info'
                  );
                  return;
                }
                filters = {
                  ...filters,
                  from: formatDateWithoutTimeZone(startDate),
                  to: formatDateWithoutTimeZone(endDate),
                };
              } else {
                return;
              }
              reduxGetAddresses(filters);
            }}
          />
        </div>
      </div>
      <div>
        <ReschedulingSolutionModal
          show={showModalReschedule}
          onHide={handleCloseReschedule}
          onEscapeKeyDown={handleCloseReschedule}
          valueManualAddressProp={valueManualAddress}
          currentTab={currentTab}
        />
      </div>
      <div>
        <ReschedulingCoordinadoraSolutionModal
          show={showCoordinadoraModal}
          onHide={handleCloseCoordinadoraModal}
          onEscapeKeyDown={handleCloseCoordinadoraModal}
          valueManualAddressProp={valueManualAddress}
          currentTab={currentTab}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    addresses: state.addressState.reschedulings,
    clients: state.companyState.clients,
    logisticsOperators: state.companyState.logisticsOperators,
    rowEdited: state.addressState.rowEdited,
    reschedule: state.addressState.reschedule,
    cities: state.cityState.cities,
    novelties: state.noveltyState.novelties,
    reschedulingsByNovelty: state.addressState.reschedulingsByNovelty,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetClients: (payload) =>
      dispatch({
        type: 'FETCH_COMPANIESBYSHIPPER_REQUEST',
        value: payload,
      }),
    reduxGetLogisticsOperators: (payload) =>
      dispatch({
        type: 'FETCH_COMPANIESBYLOGISTICSOPERATOR_REQUEST',
        value: payload,
      }),
    reduxGetAddresses: (payload) =>
      dispatch({
        type: 'FETCH_ADDRESSES_RESCHEDULING_REQUEST',
        value: payload,
      }),
    reduxGetCountByNovelty: (payload) =>
      dispatch({
        type: 'FETCH_COUNT_BY_NOVELTY_RESCHEDULING',
        value: payload,
      }),
    reduxUploadReschedulesToDrive: (payload) =>
      dispatch({
        type: 'FETCH_RESCHEDULING_UPLOAD_DRIVE_REQUEST',
        value: payload,
      }),
    reduxResetAddressForm: () =>
      dispatch({
        type: 'RESET_ADDRESS_FORM',
      }),
    reduxPatchReschedule: (payload) =>
      dispatch({
        type: 'FETCH_ADDRESS_RESCHEDULE_REQUEST',
        value: payload,
      }),
    reduxGetAddress: (payload) =>
      dispatch({
        type: 'READ_ADDRESS_REQUEST',
        value: payload,
      }),
    reduxGetNovelties: (payload) =>
      dispatch({
        type: 'FETCH_NOVELTIES_FOR_RESCHEDULE_REQUEST',
        value: payload,
      }),
    reduxGetCities: (payload) =>
      dispatch({
        type: 'FETCH_CITIES_REQUEST',
        value: payload,
      }),
    reduxGetCountries: (payload) =>
      dispatch({
        type: 'FETCH_COUNTRIES_REQUEST',
        value: payload,
      }),
    reduxResetDepartment: (payload) =>
      dispatch({
        type: 'RESET_BYCOUNTRY_DEPARTMENT',
        value: payload,
      }),
    reduxResetCity: (payload) =>
      dispatch({
        type: 'RESET_BYDEPARTMENT_CITY',
        value: payload,
      }),
    reduxResetNeighborhood: (payload) =>
      dispatch({
        type: 'RESET_BYCITY_NEIGHBORHOOD',
        value: payload,
      }),
    reduxResetAddressReschedulingForm: (payload) =>
      dispatch({
        type: 'RESET_ADDRESS_RESCHEDULING_FORM',
        value: payload,
      }),
    reduxResetCountByNovelty: () =>
      dispatch({
        type: 'RESET_TOTAL_BY_NOVELTY_RESCHEDULING',
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReschedulingTableComponent);
